/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M11.0625 1C7.3198 1 4.2443 3.9683 4.2189 7.6623 1.784 8.3795 0 10.61 0 13.2083 0 16.4181 2.665 19 5.9063 19a.75.75 0 0 0 0-1.5C3.4615 17.5 1.5 15.5581 1.5 13.2083c0-2.0626 1.5509-3.856 3.6265-4.2204l.6866-.1205-.07-.6936a4.6155 4.6155 0 0 1-.0244-.4655c0-2.8553 2.382-5.2083 5.3438-5.2083 2.5188 0 4.6429 1.6824 5.1981 4.0225l.1227.5174.5289.0554c1.0445.1094 1.8378.9734 1.8378 1.988 0 .0229-.0004.0415-.0011.0574l-.0296.6459.6345.1244c1.8308.3589 3.1462 1.9161 3.1462 3.7557 0 2.0972-1.751 3.8333-3.9375 3.8333a.75.75 0 0 0 0 1.5C21.5454 19 24 16.6239 24 13.6667c0-2.3829-1.5736-4.3993-3.7861-5.0838-.2053-1.4081-1.2637-2.5362-2.6266-2.8862C16.7052 2.9187 14.0867 1 11.0625 1Z"
    />
    <path
      fill="currentColor"
      d="M13.2446 10.9697a.75.75 0 0 1 0 1.0606l-.8891.8892c2.31.2484 4.1088 2.2044 4.1088 4.5805 0 2.5445-2.0627 4.6071-4.6072 4.6071-2.5444 0-4.6071-2.0626-4.6071-4.6071 0-.946.286-1.8276.7763-2.5601a.75.75 0 0 1 1.2465.8344A3.0893 3.0893 0 0 0 8.75 17.5c0 1.716 1.3911 3.1071 3.1071 3.1071 1.7161 0 3.1072-1.3911 3.1072-3.1071 0-1.5183-1.0889-2.7822-2.5284-3.0533l.8087.8087a.75.75 0 0 1 0 1.0606.75.75 0 0 1-1.0606 0l-2.6732-2.6731 2.6732-2.6732a.75.75 0 0 1 1.0606 0Z"
    />
  </React.Fragment>,
  'Backup'
);
